<template>
  <v-menu
    :close-on-content-click="false"
    :offset-x="isOffsetX"
    :offset-y="isOffsetY"
    :open-on-hover="isMenuOpenOnHover"
    :transition="transition"
    :value="openMenu"
    v-model="menuOpened"
    :left="left"
    :right="right"
    :position-x="positionX"
    :top="top"
    :bottom="!top"
    :class="className"
  >
    <template v-slot:activator="{ on }">
      <v-list-item
        class="d-flex justify-space-between"
        v-if="isSubMenu"
        v-on="on"
      >
        {{ name }}
        <div class="flex-grow-1"></div>
        <v-icon> mdi-chevron-right </v-icon>
      </v-list-item>
      <v-btn icon v-else v-on="on">
        <v-icon>more_vert</v-icon>
      </v-btn>
    </template>
    <v-list v-if="!showShareMCEventCard">
      <template v-for="(item, index) in menuItems">
        <SubMenu
          :is-offset-x="true"
          :is-offset-y="false"
          :is-open-on-hover="true"
          :is-sub-menu="true"
          :key="`subMenu${index}`"
          :menu-items="item.menu"
          :name="item.name"
          @sub-menu-click="emitClickEvent"
          v-if="item.menu"
          :left="true"
          :right="false"
          :showShareMCEventCard="true"
          :data="data"
          :top="true"
          className="rounded-r-0"
        />

        <v-list-item
          :key="index"
          @click="emitClickEvent(item)"
          v-else-if="item.name != 'View connections'"
        >
          <v-list-item-action v-if="item.icon">
            <v-icon>mdi-{{ item.icon }}</v-icon>
          </v-list-item-action>
          <v-list-item-title>
            {{ item.name }}
          </v-list-item-title>
        </v-list-item>

        <!--Start: If item is view connections, only show if total connections made is greater than 0--->
        <v-list-item
          :key="index"
          @click="emitClickEvent(item)"
          v-else-if="
            item.name != 'View connections' && data.noOfConnections > 0
          "
        >
          <v-list-item-action v-if="item.icon">
            <v-icon>mdi-{{ item.icon }}</v-icon>
          </v-list-item-action>
          <v-list-item-title>
            {{ item.name }}
          </v-list-item-title>
        </v-list-item>
        <!--End: If item is view connections, only show if total connections made is greater than 0--->
      </template>
    </v-list>
    <v-card
      key="multiConnectShare"
      v-else
      max-width="250"
      width="250"
      class="rounded-r-0"
    >
      <v-tabs v-model="shareMenuTab">
        <v-tab>Link</v-tab>
        <v-tab>QR code</v-tab>
      </v-tabs>
      <v-divider></v-divider>
      <v-tabs-items v-model="shareMenuTab" class="rounded-r-0">
        <v-tab-item eager class="rounded-r-0">
          <v-list class="rounded-r-0">
            <v-list-item class="py-0" @click="shareViaEmail">
              <!-- <a href="mailto:?subject=Share Multi Connect Link" class="text-decoration-none"> -->
              <v-list-item-icon class="mr-2">
                <v-icon small>mdi-email-outline</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-subtitle>Share via email</v-list-item-subtitle>
              </v-list-item-content>
              <!-- </a> -->
            </v-list-item>
            <v-list-item class="py-0" @click="copyToClipboard">
              <v-list-item-icon class="mr-2">
                <v-icon small>mdi-content-copy</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-subtitle
                  >Copy EventConnect link</v-list-item-subtitle
                >
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-tab-item>
        <v-tab-item eager>
          <div class="d-flex justify-center align-center flex-column py-4">
            <div class="text-body-2 text-left px-4 grey--text">
              Here is your unique EventConnect QR code that will direct people
              to your EventConnect link when scanned.
            </div>
            <QRCode :link="eventLink(true)" />
          </div>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </v-menu>
</template>

<script>
import QRCode from "@/components/QRCode";
import Utility from "@/shared/utility";
import { mapActions } from "vuex";

export default {
  components: {
    SubMenu: () => import("./SubMenu.vue"),
    QRCode,
  },
  props: {
    name: String,
    icon: String,
    menuItems: Array,
    color: { type: String, default: "secondary" },
    isOffsetX: { type: Boolean, default: false },
    isOffsetY: { type: Boolean, default: true },
    isOpenOnHover: { type: Boolean, default: false },
    isSubMenu: { type: Boolean, default: false },
    transition: { type: String, default: "scale-transition" },
    left: { type: Boolean, default: false },
    right: { type: Boolean, default: true },
    data: {
      type: Object,
      default: function () {
        return {};
      },
    },
    showShareMCEventCard: { type: Boolean, default: false },
    top: { type: Boolean, default: false },
    positionX: { type: Number, default: 0 },
    className: { type: String, default: "" },
  },
  created() {
    this.isMenuOpenOnHover = this.isOpenOnHover;
  },

  methods: {
    ...mapActions(["showSnackbar"]),
    eventLink(isQrCode) {
      const link= this.$appHostUrl + '/event/' + this.data.id + `?name=${this.data.name}`;
      if (isQrCode) {
        const indexOfQuery = link.indexOf('?');
        return link.substring(0, indexOfQuery);
      } else {
        return link;
      }
    },
    emitClickEvent(item) {
      this.$emit("sub-menu-click", item, this.data);
      this.openMenu = false;
      this.menuOpened = false;
    },
    shareViaEmail() {
      window.open("mailto:?subject=Share EventConnect Link");
    },
    async copyToClipboard() {
      Utility.copyToClipboard(encodeURI(this.eventLink(false)));
      this.showSnackbar({ show: true, text: "Copied to clipboard!" });
    },
  },
  watch: {
    menuOpened: function () {
      // this.isOpenOnHover = !this.menuOpened;
      this.isMenuOpenOnHover = !this.menuOpened;
    },
  },
  data: () => ({
    openMenu: false,
    // isOpenOnHover: true,
    menuOpened: false,
    shareMenuTab: 0,
    isMenuOpenOnHover: false,
  }),
};
</script>

<style></style>
